import "./authBootstrap"; // must stay first: signs every API request
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Dynamically update favicon from env var REACT_APP_TAB_ICON_URL (if provided)
const favicon = document.getElementById("favicon") as HTMLLinkElement | null;
const tabIconUrl = process.env.REACT_APP_TAB_ICON_URL;

if (favicon && tabIconUrl) {
  favicon.href = tabIconUrl;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
